/**
 * Production hostname detection for debug tooling.
 *
 * Diagnostic helpers (Eruda console, passkey traces) must never run on the live site.
 * Hostname is the only signal available at runtime: Dev is also built with `npm run build`,
 * so `import.meta.env.PROD` is true on dev.scheduledsmiles.com too.
 */

/** Hostnames that serve the production SPA. */
const PRODUCTION_HOSTNAMES = ['www.scheduledsmiles.com', 'scheduledsmiles.com'];

/** True when the page is served from the production site. */
export function isProductionHostname(hostname: string = window.location.hostname): boolean {
  return PRODUCTION_HOSTNAMES.includes(hostname);
}
